import React from "react";
import { LoadingSpinner } from "@app/form_components";
import { useCanvasTabs } from "@app/hooks";

/**
 * UI for merging application versions with options for resolving conflicts 
 *
 * @class DisabledInFlowDialog
 * @extends {React.Component}
 */
export default class DisabledInFlowDialog extends React.Component {
    /**
     * Dialog for used in reference check
     * @module DisabledInFlowDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);

        this.state = {
            disabledMapLoaded: false,
            disabledPathMap: null,
            disabledModules: null
        }
    }

    /**
     * React Lifecycle method
     *
     */
    componentDidMount() {
        this.init();
    }

    /**
     * Initialize merge by getting version changeMaps and identifying conflicts 
     *
     */
    init() {
        const {disabledPathMap, disabledModules} = this.getDisabledPathMap(this.props.modules);

        this.setState({disabledModules});
        this.setState({disabledPathMap});
        this.setState({disabledMapLoaded: true});
    }

    openCanvas(mod){
        w2popup.close();
        useCanvasTabs.getState().addTab(mod.id);
    }

    getDisabledPathMap = (mods) => {
        const disabledModules = [];
        const disabledPathMap = {};
    
        mods.forEach(mod => {

            if (mod.props.config.disabledInFlow) {
                disabledModules.push(mod);
            }
            else {
                const nodes = mod.versions[1].flow.nodes; 
                const disabledLinks = mod.versions[1].flow.links.filter(l => l.props.config.disabledInFlow); 
                
                disabledLinks.forEach(l => {
                    const startNode = nodes.find(n => n.id === l.source && !n.props.config.disabledInFlow);
                    if(startNode){
                        disabledPathMap[mod.id] = disabledPathMap[mod.id] || [];
                        disabledPathMap[mod.id].push({link: l, node: startNode})
                    }
                });   
            }
        });
        
        return {disabledModules, disabledPathMap};
        
    }
    getBody(obj){

    }
    getHeader(modId){
        const mod = this.props.modules.find(mod => mod.id === modId);
        const name = mod.name || "Un Named";

        return(<h5 key={modId} className="moduleHeader">
            <i className={"fe icon-package"} />
            <span style={{ paddingLeft: "6px" }}><a onClick={() => this.openCanvas(mod)}>{name}</a></span>
        </h5>)
    }
    getRowHeader(){

        return (<div style={{display: 'flex', backgroundColor: 'var(--theme-border-muted)', height: '2em', alignItems: 'center', padding: '.7em', fontWeight: 'bold', marginBottom: '.5em'}}>
            <div style={{flex: 1}}>Disbaled from</div>
            <div style={{flex: 1}}>Disbaled at</div>
        </div>)
    }
    getRow(paths){
        return paths.map(path => {
            const {node, link} = path;
            
            return (
                <div style={{display: 'flex', height: '1.7em', alignContent: 'center', padding: '0 .7em'}} key={`${node.id}${link.id}`}>
                    <div style={{flex: 1}}><span style={{padding: '0 .3em'}}><i className={"fe icon-" + node.props.iconClass} /></span>{node.name}</div>
                    <div style={{flex: 1}}><span style={{padding: '0 .3em'}}><i className={"fe icon-link"} /></span>{link.props.config.name || 'Un Named'}</div>
                        {/* <div>{link.props.config.condition[0]}</div> */}
                </div>
                
            )
        })
    }
    getDisabledModules(){
        const modList = []
        this.state.disabledModules.map(mod => {
            const name = mod.name;
            const iconClass = mod.props.iconClass;
            
            modList.push(
                <div key={`${mod.id}-disabled`}>
                    <i className={"fe icon-package"} /><span style={{paddingLeft: '6px'}}>{name}</span>
                </div>
            );
        })
        return modList;
    }

    getDisabledItemsInFlow(){
        return (
            Object.entries(this.state.disabledPathMap).map(obj =>{
                const modId = obj[0];
                const paths = obj[1];

                return (
                    <div key={modId}>
                        {this.getHeader(modId)}                                
                        {this.getRowHeader(modId)}                                
                        {this.getRow(paths)}
                    </div>
                );                
            })
        );
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {

        return (

            <div key={"disabled-in-flow-dialog-container"} className={"disabled-in-flow-dialog"} style={{height: '100%'}} >

                {!this.state.disabledMapLoaded &&
                    <div style={{ margin: '30% auto', height: '100%' }}>
                        <LoadingSpinner message={this.props.message} />
                    </div>
                }

                {this.state.disabledMapLoaded && this.state.disabledModules.length > 0 &&                    
                    <div style={{borderRadius: 'var(--radius-small)', padding: '10px 0px 16px', margin: '10px', border: '1px solid var(--theme-border)', padding: '1.2em'}}>
                        <h4 style={{marginTop: '0'}}>Disabled Modules</h4>
                        {this.getDisabledModules()}
                    </div>
                }
                {this.state.disabledMapLoaded && Object.keys(this.state.disabledPathMap).length > 0 &&                    
                    <div style={{borderRadius: 'var(--radius-small)', padding: '10px 0px 16px', margin: '10px', border: '1px solid var(--theme-border)', padding: '1.2em'}}>
                        <h4 style={{marginTop: '0'}}>Disabled in Flow</h4>
                        {this.getDisabledItemsInFlow()}
                    </div>
                }


            </div>

        );

    }
}

//
                    